import { render, staticRenderFns } from "./date.vue?vue&type=template&id=4b180577&scoped=true"
import script from "./date.vue?vue&type=script&lang=js"
export * from "./date.vue?vue&type=script&lang=js"
import style0 from "./date.vue?vue&type=style&index=0&id=4b180577&prod&lang=css"
import style1 from "./date.vue?vue&type=style&index=1&id=4b180577&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b180577",
  null
  
)

export default component.exports